module.exports = __webpack_public_path__ + "static/media/notification-icon-16.ab8c4442.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/notification-icon-16.png
 ** module id = 684
 ** module chunks = 0
 **/